import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IUser } from '../interfaces/user';
import { Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private rootUrl: string = "/api/users";

  constructor(private httpClient: HttpClient) { }

  public getUser(appId: number, username: string): Observable<IUser> {
    const url = this.rootUrl + "?appId=" + appId + "&username=" + username;
    return this.httpClient.get<IUser>(url);
  }

  public resetPassword(appId: number, emailAppId: number, id: string) {
    const url = this.rootUrl + "/" + id + "/reset-password?appId=" + appId + "&emailAppId=" + emailAppId;
    return this.httpClient.post(url, null);
  }
}
